import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Verifica copertura indirizzo',
  or: 'o',
  form: {
    company: {
      label: 'Seleziona ristorante',
    },
    address: {
      label: "Inserisci l'indirizzo",
    },
  },
  result: {
    positive: '{{address}} è idoneo per la consegna esterna',
    negative: '{{address}} non è idoneo per la consegna esterna',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Verifica',
  },
  toasts: {
    error: 'Verifica copertura indirizzo non riuscita',
  },
};
